import type { WorkspaceItem } from '@pn/core/domain/workspace';
import { dynamicDataProvider } from '@pn/core/services/data/dynamicDataProvider';
import { log } from '@pn/core/utils/debug';
import { uniq } from 'lodash-es';
import { getMapData, type MapData } from './mapData';

export async function getMapDataWithExtraFields(params: {
  item: WorkspaceItem;
  extraFields: string[];
}): Promise<MapData> {
  const { item, extraFields } = params;

  const mapping = await dynamicDataProvider(item.dataSource).getDataMapping(
    item
  );

  log().time('mapData [extraFields]');

  const mapData = await getMapData({
    item: {
      ...item,
      dataSource:
        item.dataSource.type === 'api'
          ? {
              ...item.dataSource,
              requiredMapDataFields: uniq([
                ...item.dataSource.requiredMapDataFields,
                ...extraFields,
              ]),
            }
          : item.dataSource,
    },
    mapping,
    silent: true,
  });

  log().timeEnd('mapData [extraFields]');
  log().info('mapData [extraFields]', mapData);

  return mapData;
}
